import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthStoreService, NavigationService } from '@app/shared/services';

/**
 * Auth Guard: Checks only if the users is authenticated.
 * - If authenticated → allow access
 * - If not authenticated → redirect to /
 */
export const authGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStoreService);
  const navigation = inject(NavigationService);

  // 認証状態の復元（Promiseとして取得）
  const currentUser = await authStore.waitForCurrentUser();
  if (currentUser) {
    return true;
  }
  navigation.navigateToRoot('/');
  return false;
};
